import React from "react";
import { Link, useParams } from "react-router-dom";

export default function VerifyEmailPage() {
    return (
        <div id="wrap">
            <Main />
        </div>
    );
}

function Main() {
    return (
        <main id="main" className="main">
            <HeadSection />
            <JoinSection />
        </main>
    );
}

function HeadSection() {
    return (
        <section className="headSection">
            <div className="container cont-960">
                <div className="wrap_head">
                    <div className="wrap_title">
                        <Link className="logo bold" to="/">
                            LOGO
                        </Link>
                        <span className="bar"></span>
                        <p className="title">스마트 AIoT 화재 모니터링 시스템</p>
                    </div>
                </div>
            </div>
        </section>
    );
}

function JoinSection() {
    const { uidb64, token } = useParams();

    return (
        <section class="joinSection">
            <div class="container cont-960">
                <div class="whiteBoard wrap_findId">
                    <p class="title_whiteBoard">회원가입을 위해 이메일을 확인해주세요.</p>
                    <div class="sub_whiteBoard">
                        회원가입 후 작성하신  이메일 <p class="user_mail">(abcd1234@gmail.com)</p>에 전송된 메세지에 <br />
                        인증을 해야 최종 회원 가입처리가 완료됩니다.
                    </div>
                </div>
                <Link class="btn_orange btn_guide_confirm" to="/">확인</Link>
            </div>
        </section>
    );
}
